import apiService from "./apiService";

const areaService = {
    async fetchMarkersFromDatabase(bounds) {
        try {
            const resp = await apiService.get(`clients/get-inbound`, {north: bounds.north,south: bounds.south,east: bounds.east, west: bounds.west}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    }
}

export default areaService;